export default __webpack_public_path__ + "static/kids-mobile-2718c9c95c338c1dc5c4747c8b5cf546.svg";